import React, { useEffect, useMemo, useState } from 'react';

import { LoadingSalesCard } from './loading-card/LoadingSalesCard';
import { OfferInformation } from '../../hooks-store/typings/incentive-store';
import { SalesEventCard } from './sales-event-card/SalesEventCard';
import { StyledSalesEventTitleWrapper, StyledSalesHome } from './styled';
import { useFeatureAppContent } from '../../hooks/use-feature-app-content';
import { useStore } from '../../hooks-store/store';
import { filterSpecialOffers } from '../../utils/general';
import {
  Breakpoints,
  TextAppearance,
  TextColor,
  TextCustom,
  TextSize,
  TextWeight,
} from '@vw-marketing/us-components';

export const HomePage = () => {
  const [loading, setLoading] = useState<boolean>(true);

  const [store] = useStore();
  const { filteredOffers = [] } = store;
  const {
    special_offers = [],
    special_offers_home_title = [],
  } = useFeatureAppContent();

  const specialOffers = useMemo<OfferInformation[]>(() => {
    return filterSpecialOffers(special_offers, filteredOffers);
  }, [special_offers, filteredOffers]);

  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  }, []);

  const { title, fontSizeSmall, fontSizeMedium, fontSizeLarge } =
    special_offers_home_title?.[0] || {};

  return (
    <StyledSalesHome>
      {title && specialOffers.length > 0 ? (
        <StyledSalesEventTitleWrapper>
          <TextCustom
            style={{
              [Breakpoints.default]: {
                fontSize: fontSizeSmall
                  ? (fontSizeSmall as any)
                  : TextSize.TextSize28,
                color: TextColor.inherit,
                fontWeight: TextWeight.bold,
              },
              [Breakpoints.b560]: {
                fontSize: fontSizeMedium
                  ? (fontSizeMedium as any)
                  : TextSize.TextSize32,
                color: TextColor.inherit,
                fontWeight: TextWeight.bold,
              },
              [Breakpoints.b1600]: {
                fontSize: fontSizeLarge
                  ? (fontSizeLarge as any)
                  : TextSize.TextSize48,
                color: TextColor.inherit,
                fontWeight: TextWeight.bold,
              },
            }}
            appearance={TextAppearance.headline300}
          >
            {title}
          </TextCustom>
        </StyledSalesEventTitleWrapper>
      ) : (
        undefined
      )}
      {loading ? (
        <LoadingSalesCard specialOffers={specialOffers} />
      ) : (
        <SalesEventCard specialOffers={specialOffers} />
      )}
    </StyledSalesHome>
  );
};
